import React from 'react';
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import SearchIcon from '@mui/icons-material/Search';
import "./orderHistory.css"
const HeaderSearchBar = ({ searchFields, handleSearchChange, handleRemoveItem, showMessage,displayedItems }) => (
  <>
 {showMessage && Object.keys(searchFields).length === 0  && (displayedItems.length >0) && (
      <div className="search-message d-flex justify-content-center mb-2">
        Click on a column header to start searching &nbsp; <SearchIcon />
      </div>
    )}

    <div className="search-container">
      {Object.keys(searchFields).map((columnName) => (
        <div key={columnName} className="searchfulldiv">
          <input
            type="text"
            placeholder={`Search By ${columnName}`}
            value={searchFields[columnName]}
            onChange={(e) => handleSearchChange(e, columnName)}
            className="search-input"
          />
          <button className="removeIcon" onClick={() => handleRemoveItem(columnName)}>
            <HighlightOffIcon />
          </button>
        </div>
      ))}
    </div>
  </>
);

export default HeaderSearchBar;
